var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9955,
    viewBox: "0 0 16 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.000117478V7.99779C8 12.4147 4.41827 15.9955 0 15.9955V7.99779C0 3.58083 3.58173 0.000117478 8 0.000117478Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 15.9953V7.99767C16 3.58072 12.4183 0 8.00001 0V7.99767C8.00001 12.4146 11.5818 15.9953 16 15.9953Z",
    fill: "#D4623A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif22);
export default __webpack_public_path__ + "static/media/motif-22.0153eb74ff158ec2acc4cb0da58c39dd.svg";
export { ForwardRef as ReactComponent };